export const GET_GENERAL_REVISION = '/get_general_revision';
export const GET_SINGLE_GENERAL_REVISION = '/get_single_general_revision';
export const UPDATE_GENERAL_REVISION = '/update_general_revision';
export const CREATE_GENERAL_REVISION = '/create_general_revision';
export const REMOVE_GENERAL_REVISION = '/remove_general_revision';

export const FORM_DATA = {
  name: '',
  revision_indicator: '',
  ordinance_revision_id: '',
  status: '',
};

export const STATUS_OPTIONS = [
  { value: 'DRAFT', label: 'DRAFT' },
  { value: 'PUBLISHED', label: 'PUBLISHED' },
];
